




















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import orderFilters from './orderFilters'

const accountModule = namespace('account')

@Component({
  name: 'result'
})
export default class Result extends Vue {
  orderFilters = orderFilters
  @accountModule.State prePaidResult!: any

  get isSuccess() {
    return this.prePaidResult && this.prePaidResult.is_success
  }
  get iconClass() {
    return this.isSuccess ? 'success' : 'failure'
  }
  get resultDesc() {
    return this.isSuccess ? '支付成功' : '支付失败'
  }

  handleConfirm() {
    this.$router.back()
  }
  handleBack() {
    this.$router.back()
  }
}
